import { getContextFromUrl } from 'config/Config';

export const texts = {
    PAGE_TITLE: 'Restauración de contraseña',
    confirmacion: {
        titulo: 'Cambio de contraseña realizado',
        mensaje: 'Puede acceder a la Oficina Virtual con su usuario habitual y la nueva contraseña.'
    }
}

export const objComponentFormio = {    
    aliasFormulario: 'restaurarContrasena',
    sp: {
        complete: 'Formulario cumplimentado correctamente',
        error: 'Hubo un problema',
        next: 'Siguiente',
        previous: 'Atrás',
        cancel: 'Cancelar',
        submit: 'Guardar',
        required: 'Es obligatorio rellenar este campo',
        confirmCancel: '¿Estás seguro que quieres cancelar?',
        submitError: 'Por favor revise el formulario y corrija todos los errores.',
        pattern: 'El valor no cumple con el patrón requerido',
        email: 'Debe ser una dirección de correo electrónico válida',
        invalid_regex: 'El valor insertado no es válido',
        characters: 'caracteres.'
    }
}

export const cruds = {
    loginRequest: {
        resource: 'login-usuario',
        url: '/setPassword'
    }
}

export const resetPassword = {
    tokenReset: '',
    newPassword: ''
}

export const properties = {
    IMAGEN_OK: `${getContextFromUrl()}` + 'email.png'
}
